// Toast.jsx
import React, { useEffect, useState } from "react";
import "./Toast.css";
import { Check, X } from "lucide-react";

const Toast = ({ message, type, duration, onClose }) => {

    const [visible, setVisible] = useState(false);

    useEffect(() => {
        // Trigger the fade-in effect
        setVisible(true);
    
        // Set a timer to fade out and close the toast
        const hideToast = setTimeout(() => {
          setVisible(false);
          // Wait for the fade-out transition before removing from DOM
          setTimeout(onClose, 300); // 300ms to match CSS transition time
        }, duration);
    
        return () => clearTimeout(hideToast);
      }, [duration, onClose]);

  return (
    <div className={`simple-toast toast-${type} ${visible ? 'visible' : ''}`}>
      {type === "error" ? (
        <div className="toast-type-cont">
          <X color="red" />
          <p> {message}</p>
        </div>
      ) : (
        <div className="toast-type-cont">
          <Check color="green" />
          <p> {message}</p>
        </div>
      )}
    </div>
  );
};

export default Toast;
